package com.essntl.features.invoice.ui.addeditinvoice.components.sidebar

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun PriceDetailsItem(
    state: PriceDetailsUiState,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.Top,
        modifier = modifier
            .fillMaxWidth(),
    ) {
        Text(
            text = state.title,
            style = MaterialTheme.esTypography.p2Regular14,
            color = MaterialTheme.esColorScheme.textPrimary,
            modifier = Modifier
                .weight(1f),
        )

        Spacer(modifier = Modifier.width(2.spacing))

        if (state.quantity > 1)
            Text(
                text = "x${state.quantity}",
                style = MaterialTheme.esTypography.s2SemiBold16,
                color = MaterialTheme.esColorScheme.textPrimary,
                modifier = Modifier.padding(end = 2.spacing),
            )

        Text(
            text = "$${
                if (state.quantity > 1 &&
                    state.unitPrice != null &&
                    state.unitPrice != state.price
                )
                    formatIntMoney(state.unitPrice) else
                    formatIntMoney(state.price)
            }",
            style = MaterialTheme.esTypography.s2SemiBold16,
            color = MaterialTheme.esColorScheme.textPrimary,
        )
    }
}